// 網路相關設定
let imgaddress = '/'
let baseaddress = ''
// ie 10 不支援 window.location.origin
if (!window.location.origin) {
  baseaddress = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
} else {
  baseaddress = window.location.origin
}

export const network = {
  // dev
  // api 網址
  baseAddress: baseaddress,
  // 圖檔資源路徑
  imgAddress: imgaddress,
  // 連線逾時秒數
  timeout: 600,
  // otp 逾時秒數
  otpTimeout: 600
}
export default network
